import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import Map from '@arcgis/core/Map';
import MapView from '@arcgis/core/views/MapView';
import WebMap from '@arcgis/core/WebMap';
import SketchViewModel from '@arcgis/core/widgets/Sketch/SketchViewModel';
import { useEffect, useState } from 'react';
import { createGraphicsLayer } from '../arcgis/jsapi/js-api-util';

let drawHandler: any;

// Sketch state.
const useSketchModel = ({
    map,
    view,
    onDrawStart,
    onDrawEnd
}: {
    map: Map | WebMap | undefined;
    view: MapView | undefined;
    onDrawStart: Function;
    onDrawEnd: Function;
}): any[] => {
    const [sketchLayer, setSketchLayer] = useState<GraphicsLayer>();
    const [sketchModel, setSketchModel] = useState<SketchViewModel>();

    // map ready.
    useEffect(() => {
        const onMapReady = async () => {
            if (view !== undefined && map !== undefined) {
                // Create the GraphicsLayer which the Sketch Widget draws on.
                const layer = await createGraphicsLayer();
                layer.listMode = 'hide';
                map.add(layer);
                setSketchModel(new SketchViewModel({ view, layer }));
                setSketchLayer(layer);
            }
        };
        onMapReady();
    }, [map, view]);

    // layer changed.
    useEffect(() => {
        if (view !== undefined && sketchModel !== undefined) {
            // Update the Sketch Widget onCreate handler.
            drawHandler?.remove();
            drawHandler = sketchModel.on('create', async (event: any) => {
                if (event.state === 'start' && onDrawStart !== undefined)
                    onDrawStart(event, sketchModel);
                else if (event.state === 'complete' && onDrawEnd !== undefined)
                    onDrawEnd(event, sketchModel);
            });
        }
    }, [onDrawEnd, onDrawStart, sketchModel, view]);

    return [sketchModel, sketchLayer];
};
export default useSketchModel;
